module.exports = __webpack_public_path__ + "media/images/front/materiales_mid_m-c7fdf032cb4b4b82a54411177ac971f5.webp";